import React, { Component } from 'react';
import PortfolioItem from './PortfolioItem';

class Portfolio extends Component {

  state = {
    portfolios: [
      {
        title: 'Rumah Makan Sederhana',
        description: 'Redesign website of Rumah Makan Sederhana, created when following Web Design competition at Surabaya',
        thumbnail: 'portfolio-1.png',
        url: 'https://quirky-lovelace-f4a7fb.netlify.com/'
      },
      {
        title: 'D3IF Telkom University',
        description: 'Redesign website of D3 Informatics, created when following Web Design competition at Bogor',
        thumbnail: 'portfolio-2.png',
        url: 'http://d3if.000webhostapp.com/'
      },
      {
        title: 'ChevalierLab Headquarters',
        description: 'Portfolio showcase website on ARKAVIDIA Coding Class Workshop at Institut Teknologi Bandung',
        thumbnail: 'portfolio-3.png',
        url: 'https://blissful-pike-4f5c7e.netlify.com/'
      },
      {
        title: 'EndlessCode',
        description: 'Learning programming website design showcases, created for qualification of OLIVIA at Surabaya',
        thumbnail: 'portfolio-4.png',
        url: 'https://naughty-montalcini-b31907.netlify.com/'
      },
      {
        title: 'TuDu App',
        description: 'A dead simple To Do List app created using ReactJS',
        thumbnail: 'portfolio-5.png',
        url: 'https://fervent-pasteur-4d6d92.netlify.com/'
      }
    ]
  }

  render() {
    const { portfolios } = this.state;
    return (
      <section className="portfolio" id="portfolio">
        <div className="container-fluid">
          <h2>Portfolio</h2>
          <PortfolioItem portfolios={portfolios} />
        </div>
      </section>
    );
  }

}

export default Portfolio;